<div [class.content-checkout]="!expressMode"
     [class.express-checkout]="expressMode"
     [hidden]="userIsAddingCard">
    <div class="checkout-container-header" [class.py-3]="expressMode">
        <div class="checkout-title">
            <div class="d-flex flex-row align-items-center">
                <div *ngIf="expressMode">
                    <p class="x-small-text text-uppercase spaced-label m-0">
                        {{ expressMode ? 'Metodos de pago' : 'Checkout' }}
                    </p>
                    <p class="small-label app-module-subtitle">Esta es tu lista de tarjetas</p>
                </div>
                <div class="ms-3" [hidden]="expressMode">
                    <h3 class="app-module-title m-0">
                        <strong>
                            {{ expressMode ? 'Metodos de pago' : 'Checkout' }}
                        </strong>
                    </h3>
                    <p class="small-label app-module-subtitle">Esta es tu lista de tarjetas</p>
                </div>
            </div>
        </div>
<!--        <div class="checkout-card-limit-reached-container" *ngIf="userReachedCardLimit">-->
<!--            <span class="material-symbols-rounded checkout-card-limit-reached-icon">info</span>-->
<!--            <div class="ms-3">-->
<!--                <p class="small-label checkout-card-limit-reached-text">-->
<!--                    Para agregar una nueva tarjeta puedes borrar una de las existentes. Puedes tener 3 tarjetas por usuario.-->
<!--                </p>-->
<!--            </div>-->
<!--        </div>-->
    </div>
    <div class="checkout-container-content">
<!--        Declined alert -->
        <div class="d-flex flex-row w-100 alert alert-danger" *ngIf="providerCardIssue">
            <div class="issued-card-left">
                <span class="material-symbols-rounded text-danger">error</span>
            </div>
            <div class="issued-card-right ms-3">
                <h6 class="text-danger m-0"><strong>Problema con la tarjeta **** {{ recentIssuedCardNumber }}</strong></h6>
                <p class="small-label retry-desc">Ocurrio un error al utilizar esta tarjeta para realizar el pago. Por favor intente con otra tarjeta.</p>
            </div>
        </div>
<!--        Insufficient founds alert -->
        <div class="d-flex flex-column w-100 alert alert-danger" *ngIf="insufficientFounds">
            <h6 class="text-danger"><strong>Fondos insuficientes en la tarjeta</strong></h6>
            <p class="small-label retry-desc">No cuentas con fondos suficientes para pagar esta compra.</p>
        </div>
        <app-payments-view [checkedPayment]="selectedPayment"
            [hidden]="userIsAddingCard"
            [inExpressMode]="expressMode"
            [payments]="cards"
            [morePayments]="true"
            [setDefaultOnTap]="setDefaultPaymentOnTap"
            (notifyPaymentSelected)="onSelectedPayment($event)"
            (notifyPaymentRemoved)="onDeletedPayment($event)"
            (notifyAddPayment)="onAddNewPayment()">
        </app-payments-view>
    </div>
    <div class="checkout-container-bottom mb-4">
        <div class="multiple-separation-bottom-actions">
            <div class="checkout-secondary-options w-100">
                <button mat-flat-button
                    *ngIf="enableOneTapPayment"
                    (click)="onCartStep()"
                    class="link-action-btn w-100">
                    <span class="material-symbols-rounded">arrow_back</span>
                    Carrito
                </button>
                <button mat-flat-button
                    class="w-100"
                    [hidden]="userReachedCardLimit"
                    [class.link-action-btn]="userHasCards"
                    [class.role-action-btn]="!userHasCards"
                    (click)="onAddNewPayment()">
                    <span class="material-symbols-rounded">add</span>
                    Agregar tarjeta
                </button>
            </div>
            <button mat-flat-button
                *ngIf="showConfirmButton"
                [disabled]="userNotMakeASelection"
                (click)="userContinue()"
                class="role-action-btn w-100">
                Continuar
            </button>
            <button mat-flat-button
                *ngIf="userHasCards && enableOneTapPayment"
                [disabled]="userNotMakeASelection"
                (click)="makeOrderProcess()"
                class="role-action-btn w-100">
                Pagar {{ total | currency }}
            </button>
        </div>
    </div>
</div>

<ng-container *ngIf="userIsAddingCard">
    <div [@fadeSlideInOut]="userIsAddingCard">
        <app-add-card (isAddedCardOk)="onIsAddedCardOk($event)"></app-add-card>
    </div>
</ng-container>
